import type { SupabaseLocalizedMessage } from "@/types";
import {
  SUPABASE_AUTH_MESSAGE_MAPPING,
  SUPABASE_MESSAGE_INCLUDES_MAPPING,
  SUPABASE_PG_MESSAGE_MAPPING,
  SUPABASE_STATUS_MESSAGE_MAPPING,
} from "./mapping";

const MAPPERS = [
  ...SUPABASE_AUTH_MESSAGE_MAPPING,
  ...SUPABASE_MESSAGE_INCLUDES_MAPPING,
  ...SUPABASE_PG_MESSAGE_MAPPING,
  ...SUPABASE_STATUS_MESSAGE_MAPPING,
];

export function localizeSupabaseError(
  error: unknown,
): SupabaseLocalizedMessage | null {
  for (const mapper of MAPPERS) {
    const out = mapper(error);
    if (out) return out;
  }

  return null;
}
